/* eslint-disable @typescript-eslint/no-unused-vars */
import { Card, Stack, Tab, Typography } from '@mui/material';
import ScrollableTabs from 'components/shared/ScrollableTabs';
import React, { useEffect, useState } from 'react';
import CustomTabPanel from './TabPanel';
import LoadingContent from 'components/LoadingContent';
// import { Button, Row } from 'react-bootstrap';
import { buildContent, buildContentCollege } from 'screen/summary/EducationSum';
import { useParams } from 'react-router-dom';
import highSchoolServices from 'services/highSchoolServices';
import {
  checkEnableParseJSON,
  formatBooleanToYesNo,
  formatDate,
  progressionHighSchool,
  hasGraduatingClassSize,
  migrateGraduatingClassSize,
} from 'components/helper/helper';
import {
  describesOptions,
  migrateWhichBestDescribeYou,
} from 'screen/education/FuturePlan/FuturePlan';
import basicInformationServices from 'services/basicInformationApi';
import { useAppSelector } from 'app/hooks';
import { buildPageStatusClassName } from './RPersonalInformation';
// import ItemContent, { CheckboxContent } from 'screen/summary/components/ItemContent';
import { PAGE_NAME, USER_ROLE } from 'constants/common';
// import { ModalCheckEducationFields } from 'screen/education/common/ModalCheckMissingFields';
import { toggleCounselorReviewedAndComplete } from 'services/reviewAndComplete';
import pageStatusService from 'services/pageStatusService';
import { usePageStatus } from 'hooks/usePageStatus';
import { getUserRole } from 'utils/sessionStorage';

const REducation = ({ setCurrentModuleId, isCounselor }: { setCurrentModuleId: (id: string) => void, isCounselor?: boolean  }) => {
  const [value, setValue] = React.useState(1);
  const checkModule = useAppSelector((store) => store.basicInformation.checkModule);
  const [isMobile, setIsMobile] = useState(false);

  const params: { id?: string | number } = useParams();
  const { pageStatus } = usePageStatus({ studentId: params.id || '' });

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setCurrentModuleId(`3.${newValue}`);
  };
  return (
    <div>
      <ScrollableTabs
        className="mt-2"
        value={value}
        onChange={handleChange}
        variant="scrollable"
        sx={{
          position: 'sticky',
          top: isCounselor ? '72px' : '0',
          left: 0,
          right: 0,
          zIndex: 11,
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'divider',
          paddingTop: '8px',
          paddingBottom: '8px',
          marginTop: 0,
          width: '100%',
          willChange: 'transform',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
        }}
      >
        <Tab value={1} label="High Schools" 
        // className={buildClassName('3.1', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.HIGH_SCHOOL)}
        />
        <Tab
          value={2}
          label="Colleges & Universities"
          // className={buildClassName('3.2', checkModule)}
          className={buildPageStatusClassName(pageStatus, PAGE_NAME.COLLEGE_AND_UNIVERSITY)}
        />
        <Tab value={3} label="Future Plans" 
        // className={buildClassName('3.3', checkModule)} 
        className={buildPageStatusClassName(pageStatus, PAGE_NAME.FUTURE_PLANS)}
        />
      </ScrollableTabs>
      <CustomTabPanel value={value} index={1}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryHighSchool isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryColleges isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <Card sx={{ backgroundColor: 'var(--ui-grey-soft, #F7F8FA)', margin: 2, padding: 2 }}>
          <Stack justifyContent={'center'} alignItems={'center'}>
            <SummaryFuturePlan isMobile={isMobile} />
          </Stack>
        </Card>
      </CustomTabPanel>
    </div>
  );
};

export default REducation;

const SummaryHighSchool = ({ isMobile }: { isMobile: boolean }) => {
  const [myHighSchool, setMyHighSchool] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [citizenshipData, setCitizenshipData] = React.useState<any>(null);
  const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(
      [PAGE_NAME.HIGH_SCHOOL, PAGE_NAME.ENROLIMENT_STATUS],
      reviewedAndComplete,
      setReviewedAndComplete
    );
  };

  const handleClose = () => setShow(false);

  // Helper function to format boolean values
  const formatBoolean = (value: any): string => {
    if (value === true || value === 'true') return 'Yes';
    if (value === false || value === 'false') return 'No';
    return value || '-';
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await highSchoolServices.getHighSchool(
        params.id === ':id' ? null : params.id
      );

      const [pageStatusResponse, pageStatusResponseEnrolmentStatus] = await Promise.all([
        pageStatusService.getPageStatusByPageName(
          params.id === ':id' ? null : params.id,
          PAGE_NAME.HIGH_SCHOOL
        ),
        pageStatusService.getPageStatusByPageName(
          params.id === ':id' ? null : params.id,
          PAGE_NAME.ENROLIMENT_STATUS
        ),
      ]);

      setReviewedAndComplete(
        pageStatusResponse?.counselor_verified &&
          pageStatusResponseEnrolmentStatus?.counselor_verified
      );

      setMyHighSchool({
        ...res,
        graduating_school_array: migrateGraduatingClassSize(
          checkEnableParseJSON(res?.graduating_school_array) || {}
        ),
        high_school_array: checkEnableParseJSON(res?.high_school_array) ?? [],
        high_school_info: checkEnableParseJSON(res?.high_school_info),
      });

      setLoading(false);
    };
    const getCitizenshipData = async () => {
      setLoading(true);
      const res: any = await basicInformationServices.getCitizenship(
        params.id === ':id' ? null : params.id
      );

      setCitizenshipData({
        ...res,
        csu_info: checkEnableParseJSON(res?.csu_info),
        statement_legal_resident: checkEnableParseJSON(res?.statement_legal_resident),
        indicator_economic_fee_waiver_array: checkEnableParseJSON(
          res?.indicator_economic_fee_waiver_array
        ),
      });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    params.id !== ':id' && getCitizenshipData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          High Schools
        </Typography>
      </div>

      {/* Enrollment Status Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Enrollment Status</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">What is your current enrollment status?*</div>
            <div className="gm-summary-field-value">
              {citizenshipData?.current_enrollment_status || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Year entering college</div>
            <div className="gm-summary-field-value">
              {citizenshipData?.year_plan_college_studies || '-'}
            </div>
          </div>
        </div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Which degree, credential, program or certificate are you applying for?
            </div>
            <div className="gm-summary-field-value">
              {citizenshipData?.csu_info?.degree_applying_for || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Which of the following best describes your current educational status?
            </div>
            <div className="gm-summary-field-value">
              {citizenshipData?.csu_info?.educational_status || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Have you earned or are you planning to earn college credit before graduating high
              school, including through concurrent or dual enrollment courses?
            </div>
            <div className="gm-summary-field-value">
              {formatBooleanToYesNo(citizenshipData?.csu_info?.is_take_college_credit) || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              I understand I am applying as a dual enrollment student to the CSU.
            </div>
            <div className="gm-summary-field-value">
              {formatBooleanToYesNo(citizenshipData?.csu_info?.is_understand_dual_enrollment) ||
                '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Select one or more of the following degree goals.
            </div>
            <div className="gm-summary-field-value">
              {Array.isArray(citizenshipData?.csu_info?.second_degree_goals) &&
              citizenshipData.csu_info.second_degree_goals.length > 0
                ? citizenshipData.csu_info.second_degree_goals.join('; ')
                : '-'}
            </div>
          </div>
        </div>
      </div>

      {/* High Schools Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">High Schools</div>

        {/* Current or Most Recent High School */}
        <div className="gm-summary-conditional-section my-16">
          <div className="gm-summary-conditional-title">Current or Most Recent High School</div>
          <div className="gm-summary-field-content">
            {buildContent(myHighSchool?.high_school_array[0], -1)}
          </div>
        </div>

        {/* Other Secondary/High School(s) */}
        <div className="gm-summary-field my-16" style={{ paddingTop: '4px' }}>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Number of other secondary/high school(s) you have attended
            </div>
            <div className="gm-summary-field-value">
              {myHighSchool?.high_school_array.length - 1 || 0}
            </div>
          </div>
        </div>

        {myHighSchool?.high_school_array?.length > 1 && (
          <div className="gm-summary-conditional-section my-16">
            <div className="gm-summary-conditional-title">Other Secondary/High School(s)</div>
            <div className="gm-summary-field-content">
              {myHighSchool?.high_school_array?.map((school: any, index: any) =>
                index !== 0 ? buildContent(school, index) : null
              )}
            </div>
          </div>
        )}

        <div className="gm-summary-field-grid mt-3">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Please provide details about why you left each of the above secondary/high schools
            </div>
            <div className="gm-summary-field-value">
              {myHighSchool?.high_school_info?.left_highschool_reason || '-'}
            </div>
          </div>
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              If there's anything else you want us to know about your academic history, you can do
              so in the space below. But remember, you should use this space only if you want to
              describe anything that you have not had the opportunity to include elsewhere in this
              section (for example: a break in attendance, poor grades in a particular course or
              year, specific information about your school environment or policies that affect your
              academic record or choices for classes).
            </div>
            <div className="gm-summary-field-label">
              Why you have missing academic year courses, aka summer courses only, at a specific
              high school listed above.*
            </div>
            <div className="gm-summary-field-value">
              {myHighSchool?.high_school_info?.academic_history || '-'}
            </div>
          </div>
        </div>
      </div>

      {/* Graduation Status Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Graduation Status</div>

        <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
          Please indicate if any of these options will have affected your progression through or
          since secondary/high school. Check all that apply.*
        </div>

        <div className="gm-summary-checkbox-container">
          {progressionHighSchool?.map((progressItem, progressIndex) => (
            <div key={progressIndex} className="gm-summary-checkbox-item">
              <div className="gm-summary-text-primary">{progressItem.label}</div>
              <div style={{ marginTop: '8px' }}>
                <div className="gm-summary-text-dark">
                  {formatBoolean(myHighSchool?.graduating_school_array[progressItem.value])}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Please use the space below to provide details about the change in progression through
              secondary/high school that you indicated above.*
            </div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.change_in_progression_through_highschool ||
                '-'}
            </div>
          </div>
        </div>

        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              Select your anticipated or current graduation status from high school or equivalent?*
            </div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.graduation_status || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Date Received/Expected*</div>
            <div className="gm-summary-field-value">
              {formatDate(
                myHighSchool?.graduating_school_array?.graduating_date_received,
                'MM-DD-YYYY'
              ) || '-'}
            </div>
          </div>
        </div>
      </div>

      {/* Graduating School Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">Graduating School</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Most recent academic year *</div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.graduating_school_year || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Class Rank Report*</div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.graduating_school_rank_report || '-'}
            </div>
          </div>
        </div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Class Rank*</div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.class_rank || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Graduating Class Size (approx.)*</div>
            <div className="gm-summary-field-value">
              {hasGraduatingClassSize(myHighSchool?.graduating_school_array?.graduating_class_size)
                ? myHighSchool.graduating_school_array.graduating_class_size
                : '-'}
            </div>
          </div>
        </div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">GPA Weighting*</div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.graduating_school_gpa_type || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">GPA Scale*</div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.graduating_school_gpa_scale || '-'}
            </div>
          </div>
        </div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Cumulative GPA*</div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.graduating_school_cumulative_gpa || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">
              How are the grades for this class reported on your transcript?
            </div>
            <div className="gm-summary-field-value">
              {myHighSchool?.graduating_school_array?.rank_weighting || '-'}
            </div>
          </div>
        </div>
      </div>

      {/* High School Counselor Information Section */}
      <div className="gm-summary-section">
        <div className="gm-summary-section-title">High School Counselor Information</div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Counselor's First Name</div>
            <div className="gm-summary-field-value">
              {myHighSchool?.counselor_first_name || '-'}
            </div>
          </div>
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Counselor's Last Name</div>
            <div className="gm-summary-field-value">{myHighSchool?.counselor_last_name || '-'}</div>
          </div>
        </div>
        <div className="gm-summary-field-grid">
          <div className="gm-summary-field-item">
            <div className="gm-summary-field-label">Counselor's Email</div>
            <div className="gm-summary-field-value">{myHighSchool?.counselor_email || '-'}</div>
          </div>
        </div>
      </div>

      {getUserRole() === USER_ROLE.counselor && (
        <div className="gm-summary-checkbox-container">
          <div className="d-flex align-items-center" style={{ gap: '6px' }}>
            <input
              type="checkbox"
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid #6c757d',
                borderRadius: '2px',
              }}
              checked={reviewedAndComplete}
              onClick={onReviewdAndComplete}
            />
            <span
              style={{
                fontSize: isMobile ? '14px' : '12px',
                color: '#6c757d',
                fontWeight: '500',
              }}
            >
              Reviewed
            </span>
          </div>
        </div>
      )}
      {/* 
      {getUserRole() === USER_ROLE.student && (
        <ModalCheckEducationFields
          show={show}
          onClose={handleClose}
          data={{
            myHighSchool: { ...myHighSchool },
            citizenshipData,
          }}
          page="highschool"
        />
      )} */}
    </div>
  );
};

const SummaryColleges = ({ isMobile }: { isMobile: boolean }) => {
  const [myCollege, setMyCollege] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [show, setShow] = React.useState(false);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.COLLEGE_AND_UNIVERSITY, reviewedAndComplete, setReviewedAndComplete);
  };

  const handleClose = () => setShow(false);

  // Helper function to format boolean values
  const formatBoolean = (value: any): string => {
    if (value === true || value === 'true') return 'Yes';
    if (value === false || value === 'false') return 'No';
    return value || '-';
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await highSchoolServices.getCollege(params.id);
      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.COLLEGE_AND_UNIVERSITY
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);
      setMyCollege({
        ...res,
        colleges_taken_coursework_array:
          checkEnableParseJSON(res?.colleges_taken_coursework_array) ?? [],
      });
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Colleges & Universities
        </Typography>
      </div>

      {myCollege && (
        <>
          {/* College Courses Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">College Courses or earned College Credit</div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Have you taken college courses or earned college credit? *
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(myCollege?.is_taken_college_courses)}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Are you currently taking courses in college? *
                </div>
                <div className="gm-summary-field-value">
                  {formatBoolean(myCollege?.is_currently_taking_courses_in_college)}
                </div>
              </div>
            </div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  How many college credits have you earned to date? *
                </div>
                <div className="gm-summary-field-value">
                  {myCollege?.number_of_college_credits_have_earned || '-'}
                </div>
              </div>
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  How many credits were earned after high school? *
                </div>
                <div className="gm-summary-field-value">
                  {myCollege?.number_of_credits_earned_after_school || '-'}
                </div>
              </div>
            </div>
          </div>

          {/* Colleges & Universities Section */}
          <div className="gm-summary-section">
            <div className="gm-summary-section-title">Colleges & Universities</div>

            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">
                  Indicate the number of colleges of universities you've taken a course at or
                  received credit from
                </div>
                <div className="gm-summary-field-value">
                  {myCollege?.number_of_colleges_taken_coursework || '-'}
                </div>
              </div>
            </div>

            {myCollege?.colleges_taken_coursework_array?.length > 0 && (
              <div className="gm-summary-conditional-section">
                <div className="gm-summary-conditional-title">Institutions Attended</div>
                <div className="gm-summary-field-content">
                  {myCollege?.colleges_taken_coursework_array?.map((item: any, index: number) =>
                    buildContentCollege(item, index)
                  )}
                </div>
              </div>
            )}
          </div>
          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #6c757d',
                    borderRadius: '2px',
                  }}
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const SummaryFuturePlan = ({ isMobile }: { isMobile: boolean }) => {
  const [data, setData] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const params: { id?: string | number } = useParams();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);

  const onReviewdAndComplete = () => {
    void toggleCounselorReviewedAndComplete(PAGE_NAME.FUTURE_PLANS, reviewedAndComplete, setReviewedAndComplete);
  };

  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const res: any = await highSchoolServices.getFuturePlan(params.id);

      const pageStatusResponse = await pageStatusService.getPageStatusByPageName(
        params.id === ':id' ? null : params.id,
        PAGE_NAME.FUTURE_PLANS
      );
      setReviewedAndComplete(pageStatusResponse?.counselor_verified);

      setData(res);
      setLoading(false);
    };
    params.id !== ':id' && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);
  return loading ? (
    <LoadingContent />
  ) : (
    <div className="gm-summary-container">
      <div className="d-flex justify-content-between mb-4">
        <Typography sx={{ fontSize: '1.75rem', fontWeight: '500', color: '#4E5A6F' }}>
          Future Plans
        </Typography>
      </div>
      {data && (
        <div className="gm-summary-section">
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item" style={{ gridColumn: '1 / -1' }}>
              <div className="gm-summary-field-label">When do you plan to start college?*</div>
              <div className="gm-summary-field-value">
                {describesOptions.find(
                  (item) =>
                    item.value === migrateWhichBestDescribeYou(data.which_best_describe_you)
                )?.label || '-'}
              </div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Career Interest</div>
              <div className="gm-summary-field-value">{data?.career_interest || '-'}</div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Other career interest*</div>
              <div className="gm-summary-field-value">{data?.other_career_interest || '-'}</div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Highest Degree you intend to earn *</div>
              <div className="gm-summary-field-value">
                {data?.highest_degree_intend_to_earn || '-'}
              </div>
            </div>
          </div>
          {getUserRole() === USER_ROLE.counselor && (
            <div className="gm-summary-checkbox-container">
              <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                <input
                  type="checkbox"
                  style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #6c757d',
                    borderRadius: '2px',
                  }}
                  checked={reviewedAndComplete}
                  onClick={onReviewdAndComplete}
                />
                <span
                  style={{
                    fontSize: isMobile ? '14px' : '12px',
                    color: '#6c757d',
                    fontWeight: '500',
                  }}
                >
                  Reviewed
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
